export const programKindEnum = Object.freeze({
    PROJECT: 1,
    CONSTRUCTION: 2,
    WARRANTY_PERIOD: 3,
    WITHDRAWAL: 4,
    NO_SIGN: 5,
    APPOINTMENT: 6,
    SIGN: 7, 
    BILLED_TO_ZERO: 8
});